import { AllPersonnelThemeModeConfig } from './types';

const light: AllPersonnelThemeModeConfig = {
  allPersonnel: {
    normalButtonBGColor: 'none',
    normalButtonBorderColor: '2px solid #267DAC',
    modalContainerBGColor: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
    modalHeaderContainerBGColor: 'lightgray',
    modalHeaderContainerFontColor: 'black',
  },
};

export default light;
